module.exports = __webpack_public_path__ + "images/anwbprivatelease66d12d8a3314973407e2c6843d29ce12.png";